import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { TxConfigActions } from './tx-config-actions';
import { IConfigState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface ITxConfigActionsProps {
  readonly warning: boolean;
}

export interface ITxConfigActionsStateProps extends ITxConfigActionsProps {
  readonly ui: IUIState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
}

export type ITxConfigActionsConnectProps = ITxConfigActionsStateProps
  & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState, props: ITxConfigActionsProps): ITxConfigActionsStateProps {
  return {
    ui: state.ui,
    upload: state.upload,
    config: state.config,
    ...props
  };
}

export const TxConfigActionsContainer: React.ComponentClass<ITxConfigActionsProps>
  = ReactRedux.connect(mapStateToProps)(TxConfigActions);
